<template>
  <div>
    <div style='padding: 15px'>
      <a-form layout='inline'>
        <a-row :gutter='24'>
          <a-col :md="10" :sm="10">
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'depositDate')" :labelCol='{span:6}' :wrapperCol='{span: 14 , offset:1}'>
              <a-range-picker
                style='width:300px;'
                v-model='queryParam.dateDt'
                format='YYYY-MM-DD'/>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'telemarketerName')">
              <a-select
                style='width: fit-content; min-width: 200px;'
                v-model='queryParam.userIds'
                mode='multiple'
              >
                <a-select-option v-for='item in userNameList' :key='item.userId'>
                  {{ item.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="6">
            <a-button type="primary" @click="searchCollectionTelMarketStatisticsInfos" icon='search'  style='margin-left: 8px'>{{ $t('search') }}</a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :data-source='dataSource'
        :loading='loading'
        :pagination='ipagination'
        bordered
        @change="handleTableChange"
      >
        <!-- 通过率 -->
        <template slot='riskPassCountRateValue' slot-scope='text, record,index'>
          {{ calculateRate(record.riskPassCount, record.applyCount) }}
        </template>
        <!-- 放款率率 -->
<!--        <template slot='installsOptRateValue' slot-scope='text, record,index'>-->
<!--          {{ calculateRate(record.optCount, record.installs) }}-->
<!--        </template>-->

      </a-table>
    </div>
  </div>
</template>
<script >
  import { filterObj } from '@/utils/util'
  import { queryTelMarketList, queryTelMarketStatisticsList,getUserNamelist } from '@/webpublicapi/collection'
  import moment from 'moment'
  const I18N_KEY = {
    COLLECTION: 'collection.'
  }
  export default {
    name: 'CollectionTelMarketStatistics'
    ,data() {
      return {
        I18N_KEY,
        loading: false,
        // 分页参数
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        userNameList:[],
        //查询条件
        queryParam: {
          dateDt: [moment().add('days' , -6) , moment().add('days' , 0)],
          userIds:[],
        }


        //回显内容
        ,dataSource: []
      }
    }
    ,computed: {
      columns() {
        return [
          //title
          {
            title: this.$t(I18N_KEY.COLLECTION + 'depositDate'),
            align: 'left',
            dataIndex: 'createTime'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'telemarketerName'),
            align: 'left',
            dataIndex: 'userName'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'taskCountTotal'),
            align: 'left',
            dataIndex: 'taskCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'overdueTaskCount'),
            align: 'left',
            dataIndex: 'overdueTaskCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'notCallCount'),
            align: 'left',
            dataIndex: 'notCallCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'missedRejectedCount'),
            align: 'left',
            dataIndex: 'missedRejectedCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'invalidCount'),
            align: 'left',
            dataIndex: 'invalidCount'
          },

          {
            title: this.$t(I18N_KEY.COLLECTION + 'noBorrowingCount'),
            align: 'left',
            dataIndex: 'noBorrowingCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'borrowingCount'),
            align: 'left',
            dataIndex: 'borrowingCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'otherCount'),
            align: 'left',
            dataIndex: 'otherCount'
          },

          {
            title: this.$t(I18N_KEY.COLLECTION + 'registerCount'),
            align: 'left',
            dataIndex: 'registerCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'applyCount'),
            align: 'left',
            dataIndex: 'applyCount'
          },
          {
            title: this.$t(I18N_KEY.COLLECTION + 'riskPassCount'),
            align: 'left',
            dataIndex: 'riskPassCount'
          }
          // ,
          // {
          //   title: this.$t(I18N_KEY.COLLECTION + 'loanCount'),
          //   align: 'left',
          //   dataIndex: 'loanCount'
          // }

        ]
      }
    }
    //初始化方法
    ,created() {
      this.loadData(1);
      getUserNamelist().then(res => {
        console.log('res',res)
        this.userNameList = res.data || []
      })
    }
    //自定义方法
    ,methods: {
      //计算利率的方法
      calculateRate(a, b) {
        if (a === 0 || b === 0) {
          return 0 + '%'
        } else if (b === 0) {
          console.log('除数为0啦救救我！！')
          // return '-'
          return 0 + '%'
        } else {
          return (a / b * 100).toFixed(2) + '%'
        }
      },
      //初始化参数
      getQueryParams() {
        const {dateDt} = this.queryParam

        const data = {
          ...this.queryParam,
          createTimeStart:dateDt && this.transformTime(dateDt[0]),
          createTimeEnd : dateDt && this.transformTime(dateDt[1])
        }
        delete data.dateDt
        data.pageNum = this.ipagination.current
        data.pageSize = this.ipagination.pageSize
        data.userIds=this.queryParam.userIds
        return data
      },
      //格式化日期
      transformTime(time) {
        return moment(time).format('YYYY-MM-DD')
      },
      //重置查询条件
      searchReset() {
        var that = this
        that.queryParam.dateDt = [moment().add('days' , -6) , moment().add('days' , 0)]
        that.queryParam.userIds=[]
        that.loadData()
      },
      //查询列表方法
      searchCollectionTelMarketStatisticsInfos() {
        console.log('查询电销统计信息列表')
        this.loadData(1)
      },
      loadData(arg) {
        //默认加载首页数据
        if(arg === 1){
          this.ipagination.current = 1
        }
        this.loading = true
        var params = this.getQueryParams()
        queryTelMarketStatisticsList(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            this.ipagination.total = res.data.total
            this.dataSource = res.data.rows
          } else {
            this.ipagination.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      },
      handleTableChange (pagination) {
        this.ipagination = pagination
        this.loadData();
      }

    }
  }
</script>



<style scoped lang='less'>
@import "~@/assets/less/common.less";

</style>